var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: `Quản lý tự động gia hạn: ${_vm.packageName}`,
            size: "xl",
            top: "4vh",
            "use-panel": false,
            "show-footer": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            cancel: _vm.handleClose,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "sk-dialog__footer" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-cancel",
                          attrs: { plain: "" },
                          on: { click: _vm.handleClose },
                        },
                        [_vm._v("Đóng")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "prd-content" },
            [
              _c("div", { staticClass: "sk-panel mb-3" }, [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c("div", { staticClass: "sk-panel-icon" }, [
                    _c("i", { staticClass: "el-icon-refresh" }),
                  ]),
                  _c("div", { staticClass: "prd-panel-text" }, [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v("Gói học phí: " + _vm._s(_vm.packageName)),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v(
                        "\n              Quản lý danh sách học sinh đăng ký tự động gia hạn, theo dõi thống kê và đợt thu\n            "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "prd-meta-badges" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            type: "primary",
                            plain: "",
                            size: "mini",
                            icon: "el-icon-question",
                          },
                          on: { click: _vm.openGuideDialog },
                        },
                        [_vm._v("\n              Hướng dẫn\n            ")]
                      ),
                      _vm.packageAutoRenew
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                effect: "dark",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-check" }),
                              _vm._v(
                                " Tự động gia hạn: Đang bật\n            "
                              ),
                            ]
                          )
                        : _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "info",
                                size: "small",
                                effect: "plain",
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-close" }),
                              _vm._v(
                                " Tự động gia hạn: Đang tắt\n            "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-tabs",
                {
                  staticClass: "sk-tabs prd-tabs",
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "STATS" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-data-analysis" }),
                        _vm._v(" Thống kê gia hạn\n          "),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingStats,
                              expression: "loadingStats",
                            },
                          ],
                        },
                        [
                          _c("div", { staticClass: "prd-stats-grid" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--active",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", { staticClass: "el-icon-check" }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats.activeRenewalCount ?? "—"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Đang tự động gia hạn")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--paused",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", {
                                    staticClass: "el-icon-video-pause",
                                  }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats.pausedRenewalCount ?? "—"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Tạm dừng gia hạn")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--cancelled",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", {
                                    staticClass: "el-icon-circle-close",
                                  }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats.cancelledRenewalCount ?? "—"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Đã hủy gia hạn")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "prd-stat-card prd-stat-card--due",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", {
                                    staticClass: "el-icon-alarm-clock",
                                  }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.stats.dueTodayCount ?? "—")
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Đến hạn hôm nay")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--cycle",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", { staticClass: "el-icon-refresh" }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.stats.cycleCount ?? "—")
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Tổng đợt gia hạn")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--invoiced",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", {
                                    staticClass: "el-icon-document-checked",
                                  }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats.invoicedStudentCycleCount ??
                                            "—"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Đã tạo phiếu thu")]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "prd-stat-card prd-stat-card--pending",
                              },
                              [
                                _c("div", { staticClass: "prd-stat-icon" }, [
                                  _c("i", { staticClass: "el-icon-time" }),
                                ]),
                                _c("div", { staticClass: "prd-stat-body" }, [
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.stats.pendingStudentCycleCount ??
                                            "—"
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "prd-stat-label" },
                                    [_vm._v("Chờ tạo phiếu thu")]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm.stats.latestCycleNo != null
                            ? _c("div", { staticClass: "prd-latest-cycle" }, [
                                _c(
                                  "div",
                                  { staticClass: "prd-latest-cycle-head" },
                                  [
                                    _c("i", { staticClass: "el-icon-date" }),
                                    _c(
                                      "span",
                                      { staticClass: "prd-latest-cycle-title" },
                                      [_vm._v("Đợt gia hạn gần nhất")]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Đợt #" +
                                            _vm._s(_vm.stats.latestCycleNo)
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "prd-latest-cycle-dates" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "prd-date-label" },
                                      [_vm._v("Thời gian áp dụng:")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "prd-date-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.stats.latestCycleStartDate
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-right prd-date-arrow",
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "prd-date-value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.stats.latestCycleEndDate
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : !_vm.loadingStats
                            ? _c("div", { staticClass: "prd-empty-cycle" }, [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  " Chưa có đợt gia hạn nào được xử lý\n            "
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "prd-stats-action" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-refresh",
                                  },
                                  on: { click: _vm.fetchStats },
                                },
                                [
                                  _vm._v(
                                    "\n                Tải lại thống kê\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "LIST" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-list" }),
                        _vm._v(" Danh sách đăng ký\n          "),
                      ]),
                      _c("div", { staticClass: "prd-note-box mb-3" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(
                          "\n            Danh sách dưới đây hiển thị các học sinh đang đăng ký gia hạn hoặc đang tạm dừng. Học sinh đã hủy sẽ xuất hiện lại tại tab "
                        ),
                        _c("strong", [_vm._v("Đăng ký hàng loạt")]),
                        _vm._v(" để đăng ký lại khi cần.\n          "),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingList,
                              expression: "loadingList",
                            },
                          ],
                          staticClass: "prd-table-wrapper",
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "sk-table",
                              attrs: {
                                data: _vm.renewalList,
                                border: "",
                                "max-height": 400,
                                "empty-text":
                                  "Không có học sinh nào đang đăng ký tự động gia hạn",
                              },
                              on: {
                                "selection-change":
                                  _vm.handleRenewalSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  align: "center",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "STT",
                                  width: "55",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "studentName",
                                  label: "Học sinh",
                                  "min-width": "160",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "prd-student-name" },
                                          [
                                            _vm._v(
                                              _vm._s(row.studentName || "—")
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ngày tham gia",
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatDate(row.enrollDate)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Chu kỳ hiện tại",
                                  "min-width": "190",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.currentCycleStartDate ||
                                        row.currentCycleEndDate
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      row.currentCycleStartDate
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-right mx-1 text-gray-400",
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      row.currentCycleEndDate
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ])
                                          : _c(
                                              "span",
                                              { staticClass: "prd-text-muted" },
                                              [_vm._v("Chưa có cycle")]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ngày hết hạn",
                                  width: "130",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "prd-text-danger":
                                                _vm.isExpiringSoon(
                                                  row.currentCycleEndDate
                                                ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    row.currentCycleEndDate
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Gia hạn tiếp theo",
                                  width: "140",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.nextRenewalDate
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "prd-text-primary",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        row.nextRenewalDate
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "prd-text-muted" },
                                              [_vm._v("—")]
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Trạng thái",
                                  width: "130",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getRenewalStatusType(
                                                row.status
                                              ),
                                              size: "small",
                                              effect: "light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getRenewalStatusLabel(
                                                    row.status
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tác vụ",
                                  width: "160",
                                  align: "center",
                                  fixed: "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Tạm dừng",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              attrs: {
                                                size: "mini",
                                                type: "warning",
                                                icon: "el-icon-video-pause",
                                                circle: "",
                                                plain: "",
                                                disabled:
                                                  row.status === "PAUSED" ||
                                                  row.status === "CANCELLED" ||
                                                  row.status === "EXPIRED" ||
                                                  !!_vm.statusLoadingMap[
                                                    row.id
                                                  ],
                                                loading:
                                                  _vm.statusLoadingMap[
                                                    row.id
                                                  ] === "PAUSED",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleUpdateStatus(
                                                    row,
                                                    "PAUSED"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Kích hoạt lại",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass: "ml-1",
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                icon: "el-icon-video-play",
                                                circle: "",
                                                plain: "",
                                                disabled:
                                                  row.status === "ACTIVE" ||
                                                  row.status === "CANCELLED" ||
                                                  row.status === "EXPIRED" ||
                                                  !!_vm.statusLoadingMap[
                                                    row.id
                                                  ],
                                                loading:
                                                  _vm.statusLoadingMap[
                                                    row.id
                                                  ] === "ACTIVE",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleUpdateStatus(
                                                    row,
                                                    "ACTIVE"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Hủy đăng ký",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass: "ml-1",
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                                icon: "el-icon-circle-close",
                                                circle: "",
                                                plain: "",
                                                disabled:
                                                  row.status === "CANCELLED" ||
                                                  row.status === "EXPIRED" ||
                                                  !!_vm.statusLoadingMap[
                                                    row.id
                                                  ],
                                                loading:
                                                  _vm.statusLoadingMap[
                                                    row.id
                                                  ] === "CANCELLED",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleUpdateStatus(
                                                    row,
                                                    "CANCELLED"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "prd-list-action mt-3" },
                        [
                          _vm.selectedRenewals.length
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "danger",
                                    icon: "el-icon-circle-close",
                                    loading: _vm.bulkCancelLoading,
                                  },
                                  on: { click: _vm.cancelSelectedRenewals },
                                },
                                [
                                  _vm._v(
                                    "\n              Hủy đăng ký đã chọn (" +
                                      _vm._s(_vm.selectedRenewals.length) +
                                      ")\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.selectedRenewals.length
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "warning",
                                    icon: "el-icon-video-pause",
                                    loading: _vm.bulkStatusLoading,
                                    disabled:
                                      _vm.selectedCountByStatus("ACTIVE") === 0,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSelectedRenewals(
                                        "PAUSED"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Tạm dừng đã chọn (" +
                                      _vm._s(
                                        _vm.selectedCountByStatus("ACTIVE")
                                      ) +
                                      ")\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.selectedRenewals.length
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "success",
                                    icon: "el-icon-video-play",
                                    loading: _vm.bulkStatusLoading,
                                    disabled:
                                      _vm.selectedCountByStatus("PAUSED") === 0,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSelectedRenewals(
                                        "ACTIVE"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Kích hoạt lại đã chọn (" +
                                      _vm._s(
                                        _vm.selectedCountByStatus("PAUSED")
                                      ) +
                                      ")\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-refresh" },
                              on: { click: _vm.fetchRenewalList },
                            },
                            [
                              _vm._v(
                                "\n              Tải lại danh sách\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "REGISTER" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-circle-plus-outline" }),
                        _vm._v(" Đăng ký hàng loạt\n          "),
                      ]),
                      _c("div", { staticClass: "prd-note-box mb-3" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(
                          "\n            Ngày bắt đầu chu kỳ gia hạn được tính tự động từ "
                        ),
                        _c("strong", [_vm._v("ngày học sinh tham gia gói")]),
                        _vm._v(
                          ". Hệ thống tự tạo chu kỳ mới ngay sau khi chu kỳ hiện tại kết thúc.\n          "
                        ),
                      ]),
                      _c("div", { staticClass: "prd-filter-card mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "prd-filter-grid" },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "prd-filter-control--grade",
                                attrs: {
                                  placeholder: "Chọn khối",
                                  clearable: "",
                                },
                                on: {
                                  change: _vm.handleRegisterGradeChange,
                                  clear: _vm.handleRegisterGradeChange,
                                },
                                model: {
                                  value: _vm.searchRegister.idGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchRegister, "idGrade", $$v)
                                  },
                                  expression: "searchRegister.idGrade",
                                },
                              },
                              _vm._l(_vm.gradeList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    value: item.id,
                                    label: item.gradeName,
                                  },
                                })
                              }),
                              1
                            ),
                            _c(
                              "el-select",
                              {
                                staticClass: "prd-filter-control--class",
                                attrs: {
                                  placeholder: "Chọn lớp",
                                  clearable: "",
                                },
                                on: {
                                  change: _vm.fetchMembers,
                                  clear: _vm.fetchMembers,
                                },
                                model: {
                                  value: _vm.searchRegister.idClass,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchRegister, "idClass", $$v)
                                  },
                                  expression: "searchRegister.idClass",
                                },
                              },
                              _vm._l(_vm.classListRegister, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    value: item.id,
                                    label: item.className,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("el-input", {
                              staticClass: "prd-search-input",
                              attrs: {
                                placeholder: "Tìm theo tên học sinh...",
                                clearable: "",
                              },
                              on: { clear: _vm.fetchMembers },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.fetchMembers.apply(null, arguments)
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c("el-button", {
                                        attrs: { icon: "el-icon-search" },
                                        on: { click: _vm.fetchMembers },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.searchRegister.fullName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchRegister, "fullName", $$v)
                                },
                                expression: "searchRegister.fullName",
                              },
                            }),
                            _c("div", { staticClass: "prd-spacer" }),
                            _c(
                              "el-button",
                              {
                                staticClass: "prd-btn-top",
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-check",
                                  size: "medium",
                                  disabled:
                                    _vm.selectedMembers.length === 0 ||
                                    _vm.loadingMembers ||
                                    _vm.loadingList ||
                                    !_vm.renewalStatusLoaded ||
                                    _vm.registerLoading,
                                  loading: _vm.registerLoading,
                                },
                                on: { click: _vm.openRegisterDialog },
                              },
                              [
                                _vm._v(
                                  "\n                Đăng ký gia hạn\n                "
                                ),
                                _vm.selectedMembers.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.selectedMembers.length) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingMembers,
                              expression: "loadingMembers",
                            },
                          ],
                          staticClass: "prd-table-wrapper",
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "membersTable",
                              staticClass: "sk-table",
                              attrs: {
                                data: _vm.memberList,
                                border: "",
                                "max-height": 400,
                                "empty-text": "Không có học sinh trong gói",
                              },
                              on: {
                                "selection-change":
                                  _vm.handleMemberSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  selectable: _vm.canRegisterMember,
                                  align: "center",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "STT",
                                  width: "55",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "fullName",
                                  label: "Họ và tên",
                                  "min-width": "180",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "prd-student-name" },
                                          [_vm._v(_vm._s(row.fullName))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Ngày sinh",
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatDate")(row.birthDay)
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "className",
                                  label: "Lớp học",
                                  "min-width": "130",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Trạng thái HS",
                                  width: "130",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.kidStatusTagType(
                                                row.kidStatus
                                              ),
                                              size: "small",
                                              effect: "light",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.kidStatusLabel(
                                                    row.kidStatus
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Trạng thái gia hạn",
                                  width: "145",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getMemberRenewalStatusType(
                                                row.idStudent
                                              ),
                                              size: "mini",
                                              effect: "plain",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getMemberRenewalStatusLabel(
                                                    row.idStudent
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Tác vụ",
                                  width: "110",
                                  align: "center",
                                  fixed: "right",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                              plain: "",
                                              icon: "el-icon-plus",
                                              disabled:
                                                !_vm.canRegisterMember(row),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openSingleRegisterDialog(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Đăng ký\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "prd-pagination" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              background: "",
                              "current-page": _vm.paginationMembers.page,
                              "page-sizes": [25, 50, 100],
                              "page-size": _vm.paginationMembers.size,
                              total: _vm.paginationMembers.total,
                              layout: "total, sizes, prev, pager, next",
                            },
                            on: {
                              "update:currentPage": function ($event) {
                                return _vm.$set(
                                  _vm.paginationMembers,
                                  "page",
                                  $event
                                )
                              },
                              "update:current-page": function ($event) {
                                return _vm.$set(
                                  _vm.paginationMembers,
                                  "page",
                                  $event
                                )
                              },
                              "update:pageSize": function ($event) {
                                return _vm.$set(
                                  _vm.paginationMembers,
                                  "size",
                                  $event
                                )
                              },
                              "update:page-size": function ($event) {
                                return _vm.$set(
                                  _vm.paginationMembers,
                                  "size",
                                  $event
                                )
                              },
                              "size-change": (val) => {
                                _vm.paginationMembers.size = val
                                _vm.paginationMembers.page = 1
                                _vm.fetchMembers()
                              },
                              "current-change": (val) => {
                                _vm.paginationMembers.page = val
                                _vm.fetchMembers()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("package-guide-dialog", { ref: "guideDialog" }),
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.registerDialogVisible,
            title: "Đăng ký tự động gia hạn",
            width: "460px",
            "append-to-body": true,
            "use-panel": false,
            "cancel-text": "Hủy",
            "confirm-text": "Xác nhận",
            "confirm-type": "primary",
            "confirm-icon": "el-icon-check",
            "confirm-loading": _vm.registerLoading,
            "confirm-disabled":
              _vm.loadingMembers || _vm.loadingList || !_vm.renewalStatusLoaded,
          },
          on: {
            "update:visible": function ($event) {
              _vm.registerDialogVisible = $event
            },
            cancel: function ($event) {
              _vm.registerDialogVisible = false
            },
            confirm: _vm.submitRegister,
          },
        },
        [
          _c("div", { staticClass: "prd-register-dialog-body" }, [
            _c("div", { staticClass: "prd-reg-summary-card mb-3" }, [
              _c("div", { staticClass: "prd-reg-summary-item" }, [
                _c("span", { staticClass: "prd-reg-label" }, [
                  _vm._v("Gói học phí:"),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "prd-reg-value font-weight-bold text-primary",
                  },
                  [_vm._v(_vm._s(_vm.packageName))]
                ),
              ]),
              _c(
                "div",
                { staticClass: "prd-reg-summary-item mt-2" },
                [
                  _c("span", { staticClass: "prd-reg-label" }, [
                    _vm._v("Số học sinh đăng ký:"),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: { size: "small", type: "primary", effect: "dark" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.registerTargetStudents.length) +
                          " học sinh\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "prd-reg-form" }, [
              _c(
                "div",
                { staticClass: "prd-form-item" },
                [
                  _c("label", { staticClass: "prd-form-label" }, [
                    _c(
                      "span",
                      { staticClass: "text-danger font-weight-bold" },
                      [_vm._v("*")]
                    ),
                    _vm._v(" Ngày đăng ký gia hạn:\n          "),
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "Chọn ngày đăng ký gia hạn",
                      format: "dd/MM/yyyy",
                      "value-format": "yyyy-MM-dd",
                      clearable: false,
                    },
                    model: {
                      value: _vm.registerEnrollDate,
                      callback: function ($$v) {
                        _vm.registerEnrollDate = $$v
                      },
                      expression: "registerEnrollDate",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "prd-reg-tip mt-3" }, [
                _c("i", { staticClass: "el-icon-info text-primary" }),
                _c("span", [
                  _vm._v(
                    "Ngày đăng ký gia hạn được gửi kèm về hệ thống để xác định thời điểm bắt đầu chu kỳ tính phí tự động."
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }